import {
    MatDialogActions,
    MatDialogContent,
    MAT_DIALOG_DATA,
    MatDialogTitle,
    MatDialogRef,
    MatDialog,
} from '@angular/material/dialog';
import {AnwesenheitslisteService, Termin, TerminAnwesenheit, TermineService, User} from 'kkm-library';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {lastValueFrom, Observable, Subscription} from 'rxjs';
import {MatButtonModule} from '@angular/material/button';
import {Component, effect, inject} from '@angular/core';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatInputModule} from '@angular/material/input';
import {ActivatedRoute, Router} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {AuthenticationService} from 'kkm-library';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Nl2brPipe} from 'kkm-library';
import {LinkyModule} from 'ngx-linky';

@Component({
    selector: 'kkm-termin-details-dialog',
    imports: [
        CommonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatIconModule,
        LinkyModule,
        Nl2brPipe,
        MatButtonToggleModule,
        FormsModule,
        MatInputModule,
        TextFieldModule,
    ],
    templateUrl: './termin-details-dialog.component.html',
    styleUrl: './termin-details-dialog.component.scss',
})
export class TerminDetailsDialogComponent {
    public authService = inject(AuthenticationService);
    public dialogRef = inject(MatDialogRef<TerminDetailsDialogComponent>);
    public dialog = inject(MatDialog);
    private listService = inject(AnwesenheitslisteService);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);

    private terminService = inject(TermineService);

    public data = inject<{termin: Termin}>(MAT_DIALOG_DATA);

    constructor() {
        if (this.data.termin) {
            this.termin = this.data.termin;

            // Anmeldung berechnen
            // if (
            //     this.termin.anmeldungen &&
            //     this.termin.anmeldungen_bis != undefined &&
            //     this.termin.anmeldungen_bis != -1
            // ) {
            //     var time = new Date(this.termin.datum).getTime() - new Date().getTime();
            //     this.termin.anmeldungen = time > this.termin.anmeldungen_bis;
            // }
        }
        effect(() => {
            this.isLoggedIn = this.authService.loginStatus();

            this.getAnmeldung();
        });

        // this.getAnmeldung();
        this.tokenSub = this.activatedRoute.queryParamMap.subscribe(params => {
            const tokenId = params.get('tokenId');
            const token = params.get('token');
            const participationState = params.get('participationState');
            this.tokenSub?.unsubscribe();
            if (participationState) {
                switch (participationState) {
                    case '1':
                        this.ownStatus = 'ja';
                        break;
                    case '2':
                        this.ownStatus = 'nein';
                        break;
                    case '3':
                        this.ownStatus = 'vielleicht';
                        break;
                    default:
                        break;
                }
                this.setStatus(this.ownStatus);
            }
            if (tokenId) this.tokenId = tokenId;
            if (token) this.token = token;
            this.getAnmeldung();
            // this.getOwnStatus();
        });
    }

    termin: Termin | undefined;
    isLoggedIn = false;

    terminAnwesenheit: TerminAnwesenheit = {anmeldung_moeglich: false};
    terminJa = 0;
    terminVielleicht = 0;
    terminNein = 0;
    terminKeine = 0;

    ownStatus = '';
    bemerkungText = '';

    tokenSub?: Subscription;
    token = '';
    tokenId = '';

    bemerkung = false;

    /** Dialog schließen */
    onCancel(): void {
        this.dialogRef.close(false);
    }

    async getAnmeldung() {
        console.log('GetAnmeldung');
        if (this.token && '' + this.termin!.id == this.tokenId) {
            this.terminAnwesenheit = await lastValueFrom(this.terminService.getTerminAnwesenheit(this.token));
            this.filterAnmeldungen();
            this.getOwnStatus();
        } else if (this.isLoggedIn && this.termin && this.termin.id) {
            this.terminAnwesenheit = await lastValueFrom(this.terminService.getTerminAnwesenheit(this.termin.id));
            this.filterAnmeldungen();
            this.getOwnStatus();
        }
    }

    async getOwnStatus() {
        let promise: Observable<User> | undefined = undefined;
        if (this.isLoggedIn && this.terminAnwesenheit.anwesenheitsliste)
            promise = this.listService.getOwnStatusById(this.terminAnwesenheit.anwesenheitsliste.id!);
        else if (this.token) promise = this.listService.getOwnStatusByToken(this.token);

        if (promise) {
            let status = await lastValueFrom(promise);
            this.ownStatus = status.pivot?.status_anmeldung || '';
            this.bemerkungText = status.pivot?.kommentar || '';
            this.bemerkung = this.bemerkungText != '';
        }
    }

    filterAnmeldungen() {
        if (this.terminAnwesenheit.anwesenheitsliste && this.terminAnwesenheit.anwesenheitsliste.user) {
            const user = this.terminAnwesenheit.anwesenheitsliste.user;

            this.terminJa = user.filter(u => u.pivot?.status_anmeldung == 'ja').length;
            this.terminVielleicht = user.filter(u => u.pivot?.status_anmeldung == 'vielleicht').length;
            this.terminNein = user.filter(u => u.pivot?.status_anmeldung == 'nein').length;
        }
        if (this.termin?.anwesenheitsliste && this.termin.anzeige_teilnehmer == 'anzahl') {
            this.terminJa = this.termin?.anwesenheitsliste.anzahlJa || 0;
            this.terminVielleicht = this.termin?.anwesenheitsliste.anzahlVielleicht || 0;
            this.terminNein = this.termin?.anwesenheitsliste.anzahlNein || 0;
        }
    }

    openListe(): void {
        this.onCancel();
        this.router.navigate(['/mitgliederbereich/anwesenheitsliste']);
        // const dialogRef = this.dialog.open(AnwesenheitslisteDialogComponent, {
        //     // height: '90%',
        //     // width: '95%',
        //     disableClose: true,
        //     data: {
        //         liste: this.termin?.anwesenheitsliste,
        //     },
        // });
    }

    setStatus(anmeldung: string, bemerkung?: string) {
        console.log('setStatus');
        if (this.terminAnwesenheit.anmeldung_moeglich) {
            console.log('setStatus Anmeldung');
            if (this.isLoggedIn) {
                console.log('setStatus loggedIn');
                lastValueFrom(
                    this.listService.addSelfToList(
                        this.terminAnwesenheit.anwesenheitsliste?.id || 0,
                        0,
                        anmeldung,
                        bemerkung,
                    ),
                );
            } else if ('' + this.termin!.id == this.tokenId) {
                console.log('setStatus Token');
                lastValueFrom(
                    this.listService.addSelfToListbyToken(
                        this.terminAnwesenheit.anwesenheitsliste?.id || 0,
                        0,
                        anmeldung,
                        bemerkung,
                        this.token,
                    ),
                );
            }
        }
    }
}
